<template>
  <div class="contact">
    <div class="border borderColordarkgray2 rounded overflow-hidden tracking-wider">
      <img class="object-contain mb-4 border-0 w-full h-full" src="~@/assets/images/banner/MAP.webp" alt="livaABC">
      <div class="service">
        <h5 class="ext-NotoSansBold text-base lg:text-lg text title font-bold px-4 md:px-8">LiveABC</h5>
        <h5 class="ext-NotoSansBold text-base lg:text-lg text title mb-3 lg:mb-5 font-bold px-4 md:px-8">The Best Language-Learning Brand You Can Trust</h5>
        <h3 class="text-NotoSansBold text-base lg:text-lg text title mb-3 lg:mb-5 font-bold px-4 md:px-8">品牌簡介</h3>
        <div class="contact-body px-4 md:px-8 mb-8 text-NotoSansRegular textColorBlack leading-relaxed">
          <h6 class="font-bold text-sm mb-1">LiveABC互動英語教學集團 數位語言學習第一品牌</h6>
          <p class="mb-4 text-sm leading-loose">LiveABC互動英語教學集團創立以來持續研發數位學習內容，累積了豐富數位出版經驗，並成為經濟部「卓越中堅企業獎」唯一數位出版廠商，同時也是臺灣第一家獲得「數位學習教材品質認證AAA級」最高榮譽的出版廠商，LiveABC擁有先進的IT技術與多媒體製作團隊，搭配專業的國內外教材編輯團隊，精心研發互動式多媒體語言學習產品，為國內數位學習的領導品牌，冀望讓學習者能夠體驗更有效率的數位學習效果。</p>
          <h6 class="font-bold text-sm mb-1">教材研發實力深獲國際肯定 各級教材行銷全球</h6>
          <p class="mb-4 text-sm leading-loose">展望全球市場，LiveABC的數位出版腳步已成功邁向國際，與全球知名出版、教育等廠商合作，以大量優質的數位語言學習內容為基礎，將優秀的數位出版產品推向全球各國，目前已成功地行銷中國、美國、歐洲、韓國、日本、泰國、越南、拉丁美洲等地，更榮獲韓國政府「教育部指定英語學習內容類大獎」，讓全世界的讀者一同見證來自臺灣的數位出版實力，和LiveABC一起互動學習，「Learning Is Very Easy with LiveABC」。</p>
          <h6 class="font-bold text-sm mb-1">建立全國最大數位學習資料庫 建立核心競爭力</h6>
          <p class="mb-4 text-sm leading-loose">LiveABC的集團事業版圖橫跨出版、教育及數位內容產業，經營實體及數位出版、數位教學、教科書出版、線上學習、華語學習、海外出版、兒童美語文教加盟、企業教育等業務項目，展望未來，LiveABC將發揮既有數位內容優勢，建立全國最大數位學習資料庫，目標成為全球最大、最專業的語言教學教材與系統生產供應商。</p>
          <h6 class="font-bold text-sm mb-1">出版品項種類豐富 滿足學習者各階段需求</h6>
          <p class="mb-4 text-sm leading-loose">LiveABC全力發展數位出版語言學習產品，並開發出互動軟體及點讀筆等數位學習工具，學習者可使用互動學習軟體加強聽說能力，帶著點讀筆隨點隨唸聆聽發音，再搭配實用的教材內容，打造完整的語言學習環境，集團每月持續發行互動英語/日語雜誌、叢書、教科書等出版品，目前已累積了超過千本的數位語言學習產品，滿足各階段的學習需求。</p>
        </div>

        <h3 class="text-NotoSansBold text-base lg:text-lg text title mb-3 lg:mb-5 font-bold px-4 md:px-8">重要記事</h3>
        <div class="contact-body px-4 md:px-8 mb-8 text-NotoSansRegular textColorBlack leading-relaxed">
          <ul class="list-decimal list-inside mb-4 text-sm">
            <li class="mb-4 leading-loose">獲頒經濟部『卓越中堅企業』，是中堅企業中唯一的數位出版廠商。</li>
            <li class="mb-4 leading-loose">與全球知名出版、教育廠商合作，產品已於全球超過20多個國家上市銷售，成功行銷國際。</li>
            <li class="mb-4 leading-loose">多次榮獲經濟部工業局、文化部以及美國、韓國等地區教育類產品獎，為臺灣數位出版業者之表率。</li>
            <li class="mb-4 leading-loose">全國首創3e教學(e-Learning、e-Teaching、e-Management)兒童美語教學體系，已有超過500家兒童美語、國中文理合作校，為臺灣英語教育紮根。</li>
            <li class="mb-4 leading-loose">線上英語課程獲全國超過300家企業指定採用為員工英語培訓平台</li>
            <li class="mb-4 leading-loose">全國有超過100所大專院校採用LiveABC出版的大專數位英語教科書及線上英語課程。</li>
            <li class="mb-4 leading-loose">榮獲全國各國高中學校採用LiveABC出版的互動英語系列雜誌作為課程輔助教材</li>
            <li class="mb-4 leading-loose">集團事業版圖橫跨出版、教育、數位內容等領域，建立全國最大語言學習數位資料庫，讓學習者透過各種載具便利學習。</li>
            <li class="mb-4 leading-loose">為國內數位學習的推動者，首創互動學習軟體、影音教學等數位學習模式，並全面推動出版品點讀化，為國內唯一可點讀朗讀之語言學習雜誌。</li>
            <li class="mb-4 leading-loose">執行城鄉智慧應用服務計畫，於全國各大城市、生活圈製作在地化英語數位教學課程，拍攝生活場域英語教學影片，提升國家英語競爭力。</li>
          </ul>

        </div>

        <h3 class="text-NotoSansBold font-bold text-base lg:text-lg text title mb-3 lg:mb-5 px-4 md:px-8">得獎記錄</h3>
        <div class="contact-body px-4 md:px-8 mb-8 text-NotoSansRegular textColorBlack leading-relaxed">
          <ul class="list-decimal list-inside mb-4 text-sm">
            <li class="mb-4 leading-loose">文化部補助發行數位出版品：<br/>「滑出國際競爭力-看CNN學英語」、「打造臺灣英語競爭力-Discovery互動英語數位出版計畫」</li>
            <li class="mb-4 leading-loose">文化部數位出版金鼎獎：<br/>「CNN全球巨星專訪-名人教你說英語」榮獲最佳語文學習類電子書獎。</li>
            <li class="mb-4 leading-loose">新聞局補助發行數位出版品：<br/>「上班族數位英語教室-biz互動英語行動學習版」榮獲補助發行數位出版品。</li>
            <li class="mb-4 leading-loose">韓國多媒體大賞：<br/>「Real biz English」韓文版Live英語實戰網，榮獲情報通信產業協會長獎。</li>
            <li class="mb-4 leading-loose">美國Horizon Interactive Award：<br/>「Live互動美語網際學院」榮獲頒發Flash類別銅牌獎。<br/>「Kids Interactive Chinese」、「Illustrated Chinese-English Dictionary」榮獲Training類別銅牌獎。</li>
            <li class="mb-4 leading-loose">韓國教育學術情報院e-learning品質認證：<br/>「21世紀情境式英語圖解字典」榮獲學校教育用e-learning產品最優秀獎</li>
            <li class="mb-4 leading-loose">韓國情報通信技術協會獎：<br/>「Kids互動英語大百科家庭篇-奇多多到我家」、「LiveABC互動英語會話百科-觀光與旅遊」榮獲GS（Good Software）認證，為韓國教育學習產品的最高榮譽獎項。</li>
            <li class="mb-4 leading-loose">行政院新聞局數位出版金鼎獎：<br/>「老外教你說英語---實戰應用篇」榮獲《最佳多媒體出版品獎》。<br/>「Kids互動英語大百科學校篇---奇多多歷險記」榮獲《最佳動漫創作獎》。</li>
            <li class="mb-4 leading-loose">經濟部工業局獎勵：<br/>榮獲「第四屆卓越中堅企業」獎項。<br/>「Live實戰英語學習網」、「CNN互動英語ipad版」榮獲《數位內容產品獎》。<br/>「大專通識英語暨商科英語數位教學系統」榮獲《創新應用類產業學習網》獎勵。<br/>「LiveABC兒童英語網際學院」榮獲《教材發展類產業學習網》獎勵。<br/>「Live互動華語數位學習內容與服務機制」榮獲《主導性新產品開發輔導計畫》獎勵。<br/>「Live互動英語教室：生活實用篇」榮獲《教學設計優等獎》。<br/>「Live實戰英語學習網」榮獲《數位內容產品獎》、《學習網最佳案例優良獎》。<br/>「Live互動英語」榮獲經濟部工業局《創新軟體產品獎》。</li>
            <li class="mb-4 leading-loose">行政院新聞局獎勵：<br/>「LiveABC互動英語會話百科-觀光與旅遊」榮獲《優良數位出版品金牌獎》。</li>
            <li class="mb-4 leading-loose">經濟部數位學習內容獎勵：<br/>「LiveABC互動英語會話大百科」榮獲開發示範性內容產品甲類（國際性）獎。</li>
            <li class="mb-4 leading-loose">資策會獎勵：「ABC互動英語」、「Live互動英語」榮獲《金學獎優良教學軟體獎教學組佳作》。</li>
            <li class="mb-4 leading-loose">行政院線上英語課程專案：「公務人員英語學習網」榮獲評選《第一名》。</li>
            <li class="mb-4 leading-loose">中國大陸教育軟件大賽：「Live互動英語」榮獲《第一名》。</li>
            <li class="mb-4 leading-loose">中國國際軟件博覽會及技術研討會：「Live互動英語」榮獲《金獎》。</li>
            <li class="mb-4 leading-loose">榮獲「HolonIQ 2021 Taiwan EdTech 50」創新代表性前50強教育科技公司。</li>
            <li class="mb-4 leading-loose">「How It Works知識大圖解」科普雜誌榮獲金鼎獎優良出版品推薦。</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  metaInfo () {
    return {
      title: '關於LiveABC',
      titleTemplate: null
    }
  },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>
